module.exports = __webpack_public_path__ + "img/liga-portugal-1-23__dark.3e84b1f1.png";